"use client";

import { RouteError } from "@/components/shared/route-error";

export default function ArtistsError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	return (
		<RouteError
			error={error}
			reset={reset}
			context="Artists"
			description="We encountered an error while loading artists. This might be temporary."
			fallbackUrl="/artists"
			fallbackLabel="Refresh page"
		/>
	);
}
